export default __webpack_public_path__ + "static/media/hero-choose-us-SIR.95a8f7f2.jpg";